import React, { useEffect, useState } from "react";
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import "jquery-ui-dist/jquery-ui";
import axiosInstance from '../axiosConfig';
import '../styles/loader.css';
import Loader from "../components/Loader";


const ContactInfo = () => {
    const [loading, setLoading] = useState(true); 
    const [address, setAddress] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await axiosInstance.get('/general-settings');
                if (response.data.success) {
                    response.data.settings.forEach(setting => {
                        if (setting.key === 'site_address') {
                            setAddress(setting.value);
                        }
                        if (setting.key === 'site_email') {
                            setEmail(setting.value);
                        }
                        if (setting.key === 'site_number') {
                            setPhone(setting.value);
                        }
                    });
                }
            } catch (error) {
                console.error("Error fetching settings:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, []);

    if (loading) {
        return <Loader />;
    }

    const ContactData = [
        {
            icon: 'fa-solid fa-location-dot de-icon gradient de-hover-scale text-dark mb20',
            heading: 'Our Address',
            content: `${address}`,
        },
        {
            icon: 'fa-solid fa-phone de-icon gradient de-hover-scale text-dark mb20',
            heading: 'Phone Number',
            content: `${phone}`,
        },
        {
            icon: 'fa-regular fa-envelope de-icon gradient de-hover-scale text-dark mb20',
            heading: 'Email Address',
            content: `${email}`,
        },
    ];

    return (
        <section id="section-content" className="no-top">
            <div className="container">
                <div className="row">
                    {ContactData.map((item, index) => (
                        <div className="col-lg-4 col-md-4 text-center med-m30" key={index}>
                            <i className={item.icon}></i>
                            <p className="lead no-bottom">{item.heading}</p>
                            <h4 className="s2">{item.content}</h4>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ContactInfo;
